import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

declare const $;

@Component({
    selector: 'color-picker',
    template: '<input #input type="text">',
    styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent implements OnInit {

    innerValue: string;

    @ViewChild('input') input: ElementRef;

    @Input()
    set color(value: string) {
        this.innerValue = value;
    }

    @Output()
    colorChange: EventEmitter<string> = new EventEmitter();

    constructor() {}

    ngOnInit() {
        $(this.input.nativeElement).spectrum({
            color: this.innerValue,
            showInput: true,
            showButtons: false,
            preferredFormat: 'hex',
            change: this.onColorChange.bind(this)
        });
    }

    onColorChange(color) {
        this.innerValue = color.toHexString();
        this.colorChange.emit(this.innerValue);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/color-picker/color-picker.component.ts